import betSlipsReducer from './betSlipsReducer';
import betTypesReducer from './betTypesReducer';
import stateReducer from './stateReducer';
import currentBetTypeSelectedReducer from './currentBetTypeSelectedReducer';
import currentBetTypeReducer from './currentBetTypeReducer';
import amountReducer from './amountReducer';
import alternativeStakeReducer from './alternativeStakeReducer';
import freebetReducer from './freebetReducer';
import isFreebetReducer from './isFreebetReducer';
import betSlipAmountsReducer from './betSlipAmountsReducer';

export default function couponReducer(coupon, action) {
    try {
        coupon = coupon.update('state', (s) => stateReducer(s, action));
        coupon = coupon.update('betSlips', (bs) => betSlipsReducer(bs, action));
        coupon = coupon.update('betSlipAmounts', (bsa) => betSlipAmountsReducer(bsa, action));
        coupon = coupon.update('betTypes', (bt) => betTypesReducer(bt, coupon.get('betSlips'), action));
        coupon = coupon.update('currentBetTypeSelected', (cbts) => currentBetTypeSelectedReducer(cbts, action));
        coupon = coupon.update('currentBetTypeIndex', (cbt) =>
            currentBetTypeReducer(
                cbt,
                coupon.get('betTypes'),
                coupon.get('currentBetTypeSelected'),
                action
            ));
        coupon = coupon.update('amount', (a) => amountReducer(a, action));
        coupon = coupon.update('alternativeStake', (a) => alternativeStakeReducer(a, action));
        coupon = coupon.update('freebet', (f) => freebetReducer(f, action));

        coupon = coupon.update('isFreebet', (f) => isFreebetReducer(f, coupon.get('freebet'), coupon.get('betSlips'),
            coupon.get('betTypes'), coupon.get('currentBetTypeIndex'), action));
    }
    catch (err) {
        for (let key in localStorage) {
            if (key.indexOf('_betSlips') !== -1 ||
                key.indexOf('_betTypes') !== -1 ||
                key.indexOf('_betSlipAmounts') !== -1 ||
                key.indexOf('_betTypeIndex') !== -1 ||
                key.indexOf('_couponState') !== -1) {
                delete localStorage[key];
            }
        }
    }

    return coupon;
}



// WEBPACK FOOTER //
// ./js/sport-betting/reducers/coupon/couponReducer.js